"use strict";
var Observable_1 = require("../../Observable");
var publishBehavior_1 = require("../../operator/publishBehavior");
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/publishBehavior.js
 ** module id = 363
 ** module chunks = 1
 **/